export default "__VITE_ASSET__CboUKhHN__"